import script from "./TitledCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TitledCard.vue?vue&type=script&setup=true&lang=js"

import "./TitledCard.vue?vue&type=style&index=0&id=02b23d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b23d6c"]])

export default __exports__